import { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
// import { useForm } from "react-hook-form";
import UserContext from "../UserContext";
import "./Register.css";
import "../styles/login.css";
import Logoname from "../img/logo/logo-name.png";
import ImgPhone from "../img/site/phone.png";
import AppStore from "../img/logo/app-store.png";
import PlayStore from "../img/logo/google-play.png";
import { LoadingOutlined } from "@ant-design/icons";
import useQuery from "../utils/useQuery";
import SEO from "../Components/SEO";

export default function Register() {
  const { loginUser, mode } = useContext(UserContext);
  // const { reset} = useForm();
  const [username, setusername] = useState("");
  const [names, setnames] = useState("");
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [cpassword, setcpassword] = useState("");
  const [loading, setLoading] = useState("");

  const query = useQuery();
  const redirect_url = query.get("redirect_url");

  const handleusername = (e) => {
    setusername(e.target.value);
  };
  const handlenames = (e) => {
    setnames(e.target.value);
  };
  const handleemail = (e) => {
    setemail(e.target.value);
  };
  const handlepassword = (e) => {
    setpassword(e.target.value);
  };
  const handlecpassword = (e) => {
    setcpassword(e.target.value);
  };

  const [message, setMessage] = useState();
  const register = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (password === cpassword) {
      try {
        await loginUser({ username, names, email, password }, "register");

        // reset(response)
        // console.log(response);
        // if (success) {
        //   window.Toast.fire({
        //     icon: 'success',
        //     title: message || 'Worked as expected'
        //   })
        //   history.push('/')
        // } else {
        //   if (typeof error !== 'string') {
        //     alert('hii')
        //     error = error[0]
        //   }
        //   window.displayToastError(error, 4000)
        // }
      } catch (e) {
        setMessage("Verification Link with OTP sent on your email");
        window.Toast.fire({
          icon: "success",
          title: "Verification Link with OTP sent on your email",
        });
      }
    } else {
      window.displayToastError("Passwords do not match");

      setLoading(false);
    }

    setLoading(false);
  };
  // setting the theme
  const [dark, setDark] = useState(false);
  useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);
  return (
    <>
      <SEO title="Create an account at Twika"></SEO>
      <div className="w-full">
        <div className="pb-9">
          <div className="lg:flex gap-5 items-center justify-center">
            <div className="w-1/4  hidden lg:block mt-100">
              <img src={ImgPhone} alt="Twika showcase" />
            </div>
            <div className="lg:w-1/4 p-0 mt-100">
              <div className="form-container border">
                {message && (
                  <div
                    className={`p-2 rounded text-center ${
                      !dark ? "bg-green-100" : "bg-green-500 text-white"
                    }`}
                  >
                    {message}
                  </div>
                )}{" "}
                <div className="logo-name w-full flex justify-center">
                  <img src={Logoname} alt="Our logo name" />
                </div>
                <div className="inputs-group">
                  <p>
                    Sign up to see stories, photos and <br />
                    events from your hommies.
                  </p>
                  <form onSubmit={register} id="form">
                    <div className="form-group">
                      <input
                        autoComplete="off"
                        type="text"
                        id="username"
                        placeholder="Username"
                        value={username}
                        onChange={handleusername}
                        className="form-control"
                      />
                    </div>

                    <div className="form-group">
                      <input
                        autoComplete="off"
                        type="text"
                        id="names"
                        placeholder="Full names"
                        value={names}
                        onChange={handlenames}
                        className="form-control"
                      />
                    </div>

                    <div className="form-group">
                      <input
                        autoComplete="off"
                        type="email"
                        id="email"
                        placeholder="Email address"
                        value={email}
                        onChange={handleemail}
                        className="form-control"
                      />
                    </div>

                    <div className="form-group">
                      <input
                        autoComplete="off"
                        type="password"
                        id="names"
                        placeholder="Password"
                        value={password}
                        onChange={handlepassword}
                        className="form-control"
                      />
                    </div>

                    <div className="form-group">
                      <input
                        autoComplete="off"
                        type="password"
                        id="names"
                        placeholder="Confirm password"
                        value={cpassword}
                        onChange={handlecpassword}
                        className="form-control"
                      />
                    </div>

                    <div className="form-group">
                      {loading ? (
                        <button
                          type="submit"
                          className="p-2 rounded-md bg-fire w-100 text-white opacity-50 flex items-center justify-center gap-1"
                          style={{ fontSize: "13px" }}
                          disabled
                        >
                          {" "}
                          <LoadingOutlined /> <span> Creating account ...</span>
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="p-2 rounded-md bg-fire w-100 text-white text-center 
                        focus:outline-none
                        "
                          style={{ fontSize: "13px" }}
                        >
                          Sign Up
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>

              <div className="border mt-1 p-1 flex justify-center items-center">
                <span>
                  Already have an account?{" "}
                  <b>
                    <Link
                      to={`/login${
                        redirect_url ? "?redirect_url=" + redirect_url : ""
                      }`}
                    >
                      {" "}
                      Login here.
                    </Link>
                  </b>
                </span>
              </div>

              {!dark && (
                <div className="mt-1 p-1 form-container">
                  <div className="account2">
                    <div className="app-stores flex w-full justify-center">
                      <img src={AppStore} alt="App Store" className="mr-2" />
                      <img
                        src={PlayStore}
                        alt="Google Play Store"
                        className="ml-2"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* <LoginFooter /> */}
      </div>
    </>
  );
}
